import { simpleSelectorCreator } from 'shared/helpers';
import { reducerNames } from 'shared/constants';

const sub = `${reducerNames.ui}.`;

export const getShowResetResultModal = simpleSelectorCreator(`${sub}showResetResultModal`, false);

export default {};
